import { toast } from 'react-hot-toast'

const TOAST_DURATION = 6000 // 6 seconds in milliseconds

export const toastError = (message) => {
    toast.error(message, {
        duration: TOAST_DURATION,
        // Additional toast options can be set here if needed
    })
}

export const toastSuccess = (message) => {
    toast.success(message, {
        duration: TOAST_DURATION,
        // Additional toast options can be set here if needed
    })
}
